// src/components/badge/index.tsx
import React from "react";
import { badge } from "@pinatagrams/design-system/recipes";
import { jsx } from "react/jsx-runtime";
var Badge = React.forwardRef(
  ({ color, size = "md", children, ...props }, ref) => {
    const className = badge({ color, size });
    return /* @__PURE__ */ jsx("span", { ref, role: "status", "aria-live": "polite", className, ...props, children });
  }
);
Badge.displayName = "Badge";
var badge_default = Badge;
export {
  Badge,
  badge_default as default
};
//# sourceMappingURL=badge.js.map